export default {
  'password': 'Please enter password',
  'passwordError': 'The password is 8-20 digits, and only supports three or more combinations of uppercase and lowercase letters, numbers and symbols',
  'passwordAgain': 'Please enter password again',
  'passwordNotSame': 'The entered passwords are inconsistent. Please enter again',
  'requiredVerifyCode': 'Please enter verification code',
  'verifyCode': 'Verification code error'
}
